import { processingSessionIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";
import {
  InventoryItemDispositionSchema,
  InventoryItemGradeSchema,
} from "./create-inventory-item";
import { ItemProcessingSession } from "./item-processing";
import { ItemProcessingStatusSchema } from "./processing-session";

export const updateItemProcessingSession = {
  name: "updateItemProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    status: ItemProcessingStatusSchema.optional(),
    grade: InventoryItemGradeSchema.nullish(),
    outcome: InventoryItemDispositionSchema.nullish(),
    notes: z.string().nullish(),
  }),
  output: z.object({ session: ItemProcessingSession }),
};
